export default "__VITE_ASSET__41b35762__"